//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default{
  data(){
    return{
      showimg:false,
      dataUrl:'',
      weixin:Boolean,
      nickname:'',
      headimgurl:'',
      url:''
    }
  },
  mounted(){
    this.checkWeiXin()
  },
  methods: {
    checkWeiXin() {
      let data = 'cmd=check_wx_bind'
      this.$http.post('https://api.abeiyun.com/www/user.php',data).then(({data})=>{
        if(data.response == 200){
          this.weixin = true
          this.nickname = data.msg.nickname
          this.headimgurl = data.msg.headimgurl
        }else{
          this.weixin = false
        }
      })
    },
    imgPreview (file) {
      let self = this;
      // 看支持不支持FileReader
      if (!file || !window.FileReader) return;

      if (/^image/.test(file.type)) {
        // 创建一个reader
        var reader = new FileReader();
        // 将图片将转成 base64 格式
        reader.readAsDataURL(file);
        // 读取成功后的回调
        reader.onloadend = function () {
          self.dataUrl = this.result;
        }
      }
      this.showimg = true
    },
    handleFileChange () {
      let inputDOM = this.$refs.inputer;
      // 通过DOM取文件数据
      this.file  = inputDOM.files[0];
      // 这里就可以获取到文件的名字了
      this.fileName = this.file.name;

      this.imgPreview(this.file);
    },
    async submit() {
      let formData = new window.FormData();
      formData.append('cmd', 'free_delay_add')
      formData.append('ptype', 'vhost')
      formData.append('url', this.url)
      formData.append('yanqi_img', this.$refs.inputer.files[0])
      let _this = this
      this.$vux.loading.show({
        text: 'Loading'
      })
      this.$http.post('https://api.abeiyun.com/www/renew.php',formData).then(({data})=>{
        if(data.response == 200){
          this.$vux.loading.hide()
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
            onHide () {
              _this.showimg = false
              _this.$router.push('/user/vhostrecord')
            }
          })
        }else{
          this.$vux.loading.hide()
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
          })
        }
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/console/freevhostdelay.vue